(() => {
  if(customElements.get('arclo-cart-coupon-source'))return;
  class ArcloCartCoupon extends HTMLElement {
    connectedCallback(){
      if(this.controller)return;
      this.controller=new AbortController();
      this.querySelector('button').addEventListener('click',async()=>{
        const button=this.querySelector('button'),code=this.querySelector('code').textContent.trim(),status=this.querySelector('[data-copy-status]');
        button.disabled=true;status.textContent='';
        let copied=false;
        try{await navigator.clipboard.writeText(code);copied=true;}catch{
          // Support older browsers / clipboard permission denial without changing the cart.
          const input=document.createElement('textarea');input.value=code;input.setAttribute('readonly','');input.style.cssText='position:fixed;left:-9999px;top:0';this.append(input);input.select();
          try{copied=document.execCommand('copy');}catch{}input.remove();button.focus({preventScroll:true});
        }
        button.textContent=copied?'COPIED':'COPY';button.disabled=false;
        status.textContent=copied?'Discount code copied.':'Select the code and copy it manually.';
        if(!copied){const selection=getSelection(),range=document.createRange();range.selectNodeContents(this.querySelector('code'));selection.removeAllRanges();selection.addRange(range);}
        clearTimeout(this.timer);this.timer=setTimeout(()=>{button.textContent='COPY';},3000);
      },{signal:this.controller.signal});
    }
    disconnectedCallback(){this.controller?.abort();this.controller=null;clearTimeout(this.timer);}
  }
  customElements.define('arclo-cart-coupon',ArcloCartCoupon);
  class ArcloCartCouponSource extends HTMLElement {
    connectedCallback(){
      if(this.observer)return;
      this.owner=this.dataset.owner;
      const mount=()=>{
        const drawer=document.getElementById('MinimogCartDrawer');
        if(!drawer)return;
        if(this.drawer!==drawer){this.observer?.disconnect();this.drawer=drawer;this.observer=new MutationObserver(()=>this.mount());this.observer.observe(drawer,{childList:true,subtree:true});}
        this.mount();
      };
      this.mount=()=>{
        const footer=this.drawer.querySelector('.m-cart-drawer__footer--wrapper');
        if(!footer||footer.querySelector('arclo-cart-coupon'))return;
        const fragment=this.querySelector('template').content.cloneNode(true);
        fragment.querySelector('arclo-cart-coupon').dataset.owner=this.owner;footer.prepend(fragment);
      };
      mount();
      if(!this.drawer){this.observer=new MutationObserver(mount);this.observer.observe(document.body,{childList:true,subtree:true});}
    }
    disconnectedCallback(){this.observer?.disconnect();this.observer=null;this.drawer?.querySelectorAll('arclo-cart-coupon').forEach(el=>{if(el.dataset.owner===this.owner)el.remove();});}
  }
  customElements.define('arclo-cart-coupon-source',ArcloCartCouponSource);
})();
